module.exports = __webpack_public_path__ + "static/img/200083.036c6df1.png";